import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Card,
  Button,
  CardContent,
  LinearProgress,
  Stack,
  Paper,
  FormControl,
  OutlinedInput,
  InputAdornment,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  TextField,
} from "@mui/material";
import { createSvgIcon } from "@mui/material/utils";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useContentUpload from "../../../hooks/useContentUpload";
import {
  deleteExamAction,
  fetchExamsAction,
  fetchSubjectAction,
  flagExamPaper,
  VerifyExam,
} from "../../../redux/contentUpload/contentUploadActions";
import { useParams } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import useAdminUser from "../../../hooks/useAdminUser";
import { useNotifications } from "../../../components/notifications/notifications";
import PropTypes from "prop-types";
import { isArray } from "../../../helpers/helper";
import SubjectTopics from "./SubjectTopics";
import {
  Flag,
  Verified,
  Edit,
  Delete,
  VerifiedUser,
  Unpublished,
  OutlinedFlag,
} from "@mui/icons-material";
import FlagIcon from "@mui/icons-material/Flag";
import Loader from "../../../components/AuthReuseables/Preloader/Loader";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PlusIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4.5v15m7.5-7.5h-15"
    />
  </svg>,
  "Plus"
);

const ContentUploadExam = () => {
  const { id } = useParams();
  const { examData, singleSubject, loading, error } = useContentUpload();
  const [deleteModal, setDeleteModal] = useState(false);
  const [VerifyModal, setVerifyModal] = useState(false);
  const [flagReason, setFlagReason] = useState("");
  const [deleteExam, setDeleteExam] = useState(false);
  const [examId, setExamId] = useState("");
  const { userInfo } = useAdminUser();
  const [ToastState, setToastState] = useNotifications();
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [loadExam, setLoadExam] = useState(false);
  const [value, setValue] = React.useState(0);
  const [flag, setFlag] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      dispatch(fetchExamsAction(id));
      dispatch(fetchSubjectAction(id));
    }
  }, [deleteExam, loadExam]);

  useEffect(() => {
    if (search != "") {
      setFilteredData(
        examData?.filter((exam) =>
          exam.year.toLowerCase()?.includes(search.toLowerCase())
        )
      );
    } else {
      setFilteredData(examData);
    }
  }, [search]);

  useEffect(() => {
    setLoadExam(false);
    setFilteredData(examData);
  }, [loadExam, examData]);

  const handleExamEdit = (exam) => {
    navigate("/admin/contentupload/examsetup", {
      state: { exam: exam, subjectId: id },
    });
  };

  const handleVerifyExam = (exam) => {
    setVerifyModal(false);
    const data = {
      ExamId: exam.examId,
      verify: exam.locked ? 0 : 1,
    };
    dispatch(VerifyExam(data, onVerifySuccess(exam)));
  };

  const handleFlagExam = (exam) => {
    setFlag(false);
    const data = {
      ExamId: exam.examId,
      flag: exam.isExamFlagged ? 0 : 1,
      reasonForFlag: exam.isExamFlagged == 0 ? " " :flagReason,
    };
    dispatch(flagExamPaper(data, onFlagSuccess, onFail));
  };

  const onSuccess = () => {
    setToastState({
      isOpen: true,
      severity: "success",
      message: "Exam deleted successfully",
    });
    setDeleteExam(false);
    setLoadExam(true);
  };
  const onFlagSuccess = () => {
    setToastState({
      isOpen: true,
      severity: "success",
      message: "Exam flagged successfully",
    });
    setLoadExam(true);
  };
  const onFail=()=>{
    setToastState({
      isOpen: true,
      severity: "error",
      message: "Exam verified unsuccessfully",
    })
  }
  const onVerifySuccess = (exam) => {
    setLoadExam(true);
    setToastState({
      isOpen: true,
      severity: "success",
      message: `Exam ${exam?.locked ? "unverified" : "verified"} successfully`,
    });
  };
  const handleCommentSubmit = () => {
    setFlagReason(flagReason);
    setFlag(false);
  };
  const handleDeleteExam = (exam) => {
    setDeleteModal(false);
    const data = {
      id: exam.examId,
      adminProfileId: userInfo?.data?.profileId,
    };
    dispatch(deleteExamAction(data, onSuccess));
  };

  const goBack = () => {
    navigate("/admin/contentupload");
  };

  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return date.toLocaleDateString("en-GB", options).replace(/\//g, "/");
  }

  const getPercentCompletion = (exam) => {
    let percent = 0;
    if (exam?.examStatus == 1) {
      percent = 25;
    }
    if (exam?.examStatus == 2) {
      percent = 50;
    }
    if (exam?.examStatus > 1 && exam?.examInstruction) {
      percent = 75;
    }
    return percent;
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Typography
        sx={{
          color: "#000",
          fontFamily: "Open Sans",
          fontSize: "36px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "50.4px",
        }}
      >
        Content Upload
      </Typography>
      {/* <Typography sx={{
        color: '#313131',
        fontFamily: 'Open Sans',
        fontSize: '16px', fontStyle: 'normal', fontWeight: 400,
        lineHeight: '22.4px'
      }}>
        Select year to modify</Typography> */}
      <div className="flex justify-between items-center">
        <div className="flex space-x-3 items-center pt-3">
          <button
            className="btn"
            style={{
              color: "#40499D",
              borderRadius: "5px",
              padding: "5px 7px",
              fontSize: "15px",
              fontWeight: 400,
            }}
            onClick={() => goBack()}
          >
            <span className="my-2">
              <ArrowBackIosNewIcon />
            </span>
          </button>
          <h3 className="ml-3 e-study-heading-three">
            {singleSubject?.subjectName}
          </h3>
        </div>
      </div>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="Papers"
            {...a11yProps(0)}
            sx={{ textTransform: "none" }}
          />
          <Tab
            label="Topics"
            {...a11yProps(1)}
            sx={{ textTransform: "none" }}
          />
          {/* <Tab label="Pages" {...a11yProps(1)} sx={{ textTransform: 'none' }} onClick={handleDisplay3} /> */}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Box sx={{ my: 3 }}>
          <Card variant="outlined">
            <CardContent sx={{ pb: 1 }}>
              <Grid container spacing={1} alignItems={"center"}>
                <Grid item xs={6}>
                  <FormControl sx={{ mt: 1 }}>
                    <OutlinedInput
                      id="outlined-adornment-search"
                      startAdornment={
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      }
                      size="small"
                      placeholder="search exam year..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <div className="flex space-x-4 items-center justify-end">
                    <div className="flex">
                      <Button
                        variant="outlined"
                        sx={{
                          textTransform: "none",
                          color: "#000",
                          borderColor: "#000",
                          backgroundColor: "#F6F6F6",
                        }}
                        startIcon={<FilterListIcon />}
                      >
                        Filters
                      </Button>
                    </div>
                    <div className="flex">
                      <Button
                        sx={{
                          backgroundColor: "#40499D",
                          borderRadius: 2,
                          textTransform: "none",
                        }}
                        variant="contained"
                        startIcon={<PlusIcon />}
                        onClick={() =>
                          navigate("/admin/contentupload/examsetup", {
                            state: { subjectId: id },
                          })
                        }
                      >
                        Add new exam
                      </Button>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>

        {loading && <Loader />}
        {!loading &&
        <Grid container spacing={2}>          
          {filteredData?.length > 0 ? (
            filteredData?.map((exam, i) => (
              <Grid item xs={12} lg={6} key={i}>
                <Card
                  variant="outlined"
                  sx={{ minWidth: 275, borderRadius: "16px" }}
                >
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={9}>
                        <div className="flex justify-between gap-4">
                          <Typography
                            style={{
                              color: "#313131",
                              fontFamily: "Open Sans",
                              fontSize: "12x",
                              fontStyle: "normal",
                              fontWeight: 600,
                              lineHeight: "16.34px",
                              marginBottom: "12px",
                              mt: 2,
                            }}
                          >
                            Created: {formatDate(exam.dateCreated)}
                          </Typography>
                          <div className="flex gap-2">
                            {exam?.locked && (
                              <div className="flex gap-2">
                                <h3 className="text-[#367d39] font-bold">
                                  Verified
                                </h3>
                                <Verified className="size-12" color="success" />
                              </div>
                            )}
                            {exam?.isExamFlagged && (
                              <Tooltip
                                 title={exam?.reasonForFlag}
                                arrow
                              >                                
                                  <ToggleButton

                                    // value="active"
                                    style={{
                                      color:
                                        "red",
                                        border:"none",
                                       padding: "0px",
                                    }}
                                  >
                                    <Flag />
                                  </ToggleButton>
                              </Tooltip>
                            )}
                          </div>
                        </div>

                        <Typography
                          sx={{
                            color: "#313131",
                            fontFamily: "Open Sans",
                            fontSize: "18px",
                            fontWeight: 600,
                            lineHeight: "24.51px",
                            mb: 1,
                          }}
                        >
                          {exam.examName}
                        </Typography>
                        <Typography
                          style={{
                            color: "#313131",
                            fontFamily: "Open Sans",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "21.79px",
                          }}
                        >
                          {exam.year}
                        </Typography>
                        <Typography
                          style={{
                            color: "#313131",
                            fontFamily: "Open Sans",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "22.4px",
                          }}
                        >
                          {getPercentCompletion(exam)}% completed
                        </Typography>
                        <Box sx={{ width: "100%" }}>
                          <LinearProgress
                            sx={{ borderRadius: 2, my: 1 }}
                            color="success"
                            variant="determinate"
                            value={getPercentCompletion(exam)}
                          />
                        </Box>
                        <Typography
                          style={{
                            color: "#313131",
                            fontFamily: "Open Sans",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "22.4px",
                          }}
                        >
                          {exam.questionCount} question
                          {exam?.questionCount > 1 ? "s" : ""}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <div className="flex gap-2">
                          <svg
                            width="112"
                            height="112"
                            viewBox="0 0 112 112"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0 56C0 86.9279 25.0721 112 56 112C86.9279 112 112 86.9279 112 56C112 25.0721 86.9279 0 56 0C25.0721 0 0 25.0721 0 56ZM97.7935 56C97.7935 79.0819 79.0819 97.7935 56 97.7935C32.9181 97.7935 14.2065 79.0819 14.2065 56C14.2065 32.9181 32.9181 14.2065 56 14.2065C79.0819 14.2065 97.7935 32.9181 97.7935 56Z"
                              fill="#F8EF07"
                            />
                            <path
                              d="M56 7.10326C56 3.18024 59.1928 -0.0463943 63.0843 0.449898C69.824 1.30943 76.3714 3.391 82.3982 6.61241C90.5201 10.9536 97.4459 17.2309 102.562 24.8881C107.679 32.5453 110.828 41.3461 111.73 50.511C112.633 59.6759 111.261 68.922 107.737 77.4303C104.213 85.9385 98.6449 93.4463 91.526 99.2886C84.4072 105.131 75.9574 109.127 66.9251 110.924C57.8928 112.721 48.5568 112.262 39.7441 109.589C33.2046 107.605 27.103 104.447 21.7295 100.289C18.6269 97.8885 18.6508 93.3492 21.4248 90.5752C24.1988 87.8012 28.6688 87.8605 31.872 90.1253C35.5179 92.703 39.566 94.6888 43.868 95.9939C50.445 97.989 57.4126 98.3313 64.1535 96.9904C70.8944 95.6496 77.2006 92.667 82.5135 88.3068C87.8264 83.9466 91.982 78.3435 94.6121 71.9937C97.2423 65.6439 98.2659 58.7434 97.5922 51.9035C96.9185 45.0636 94.5684 38.4955 90.75 32.7808C86.9316 27.0661 81.7627 22.3813 75.7013 19.1414C71.7365 17.0222 67.4699 15.564 63.0692 14.8087C59.2027 14.1451 56 11.0263 56 7.10326Z"
                              fill="#40499D"
                            />
                            <path
                              d="M30.0566 47.4336C31.1621 47.4336 31.9688 47.6602 32.4766 48.1133C32.9844 48.5664 33.2383 49.2012 33.2383 50.0176C33.2383 50.3887 33.1797 50.7422 33.0625 51.0781C32.9492 51.4102 32.7617 51.7051 32.5 51.9629C32.2383 52.2168 31.8926 52.418 31.4629 52.5664C31.0371 52.7148 30.5117 52.7891 29.8867 52.7891H28.9727V56H27.5664V47.4336H30.0566ZM29.9629 48.5996H28.9727V51.6172H29.7402C30.1816 51.6172 30.5566 51.5664 30.8652 51.4648C31.1738 51.3594 31.4082 51.1934 31.5684 50.9668C31.7285 50.7402 31.8086 50.4414 31.8086 50.0703C31.8086 49.5742 31.6582 49.2051 31.3574 48.9629C31.0605 48.7207 30.5957 48.5996 29.9629 48.5996ZM40.5508 52.7422C40.5508 53.2812 40.4805 53.7598 40.3398 54.1777C40.1992 54.5957 39.9941 54.9492 39.7246 55.2383C39.4551 55.5234 39.1309 55.7422 38.752 55.8945C38.373 56.043 37.9453 56.1172 37.4688 56.1172C37.0234 56.1172 36.6152 56.043 36.2441 55.8945C35.873 55.7422 35.5508 55.5234 35.2773 55.2383C35.0078 54.9492 34.7988 54.5957 34.6504 54.1777C34.502 53.7598 34.4277 53.2812 34.4277 52.7422C34.4277 52.0273 34.5508 51.4219 34.7969 50.9258C35.0469 50.4258 35.4023 50.0449 35.8633 49.7832C36.3242 49.5215 36.873 49.3906 37.5098 49.3906C38.1074 49.3906 38.6348 49.5215 39.0918 49.7832C39.5488 50.0449 39.9062 50.4258 40.1641 50.9258C40.4219 51.4258 40.5508 52.0312 40.5508 52.7422ZM35.8457 52.7422C35.8457 53.2148 35.9023 53.6191 36.0156 53.9551C36.1328 54.291 36.3125 54.5488 36.5547 54.7285C36.7969 54.9043 37.1094 54.9922 37.4922 54.9922C37.875 54.9922 38.1875 54.9043 38.4297 54.7285C38.6719 54.5488 38.8496 54.291 38.9629 53.9551C39.0762 53.6191 39.1328 53.2148 39.1328 52.7422C39.1328 52.2695 39.0762 51.8691 38.9629 51.541C38.8496 51.209 38.6719 50.957 38.4297 50.7852C38.1875 50.6094 37.873 50.5215 37.4863 50.5215C36.916 50.5215 36.5 50.7129 36.2383 51.0957C35.9766 51.4785 35.8457 52.0273 35.8457 52.7422ZM45.4609 49.3906C46.2305 49.3906 46.8477 49.6719 47.3125 50.2344C47.7812 50.7969 48.0156 51.6328 48.0156 52.7422C48.0156 53.4766 47.9062 54.0957 47.6875 54.5996C47.4727 55.0996 47.1699 55.4785 46.7793 55.7363C46.3926 55.9902 45.9414 56.1172 45.4258 56.1172C45.0977 56.1172 44.8125 56.0742 44.5703 55.9883C44.3281 55.9023 44.1211 55.791 43.9492 55.6543C43.7773 55.5137 43.6328 55.3613 43.5156 55.1973H43.4336C43.4531 55.3535 43.4707 55.5273 43.4863 55.7188C43.5059 55.9062 43.5156 56.0781 43.5156 56.2344V58.877H42.1328V49.5137H43.2578L43.4512 50.4102H43.5156C43.6367 50.2266 43.7832 50.0566 43.9551 49.9004C44.1309 49.7441 44.3418 49.6211 44.5879 49.5312C44.8379 49.4375 45.1289 49.3906 45.4609 49.3906ZM45.0918 50.5156C44.7129 50.5156 44.4082 50.5918 44.1777 50.7441C43.9512 50.8926 43.7852 51.1172 43.6797 51.418C43.5781 51.7188 43.5234 52.0957 43.5156 52.5488V52.7422C43.5156 53.2227 43.5645 53.6309 43.6621 53.9668C43.7637 54.2988 43.9297 54.5527 44.1602 54.7285C44.3945 54.9004 44.7109 54.9863 45.1094 54.9863C45.4453 54.9863 45.7227 54.8945 45.9414 54.7109C46.1641 54.5273 46.3301 54.2656 46.4395 53.9258C46.5488 53.5859 46.6035 53.1855 46.6035 52.7246C46.6035 52.0254 46.4785 51.4824 46.2285 51.0957C45.9824 50.709 45.6035 50.5156 45.0918 50.5156ZM55.2637 49.5137V56H54.1797L53.9922 55.127H53.916C53.7793 55.3496 53.6055 55.5352 53.3945 55.6836C53.1836 55.8281 52.9492 55.9355 52.6914 56.0059C52.4336 56.0801 52.1621 56.1172 51.877 56.1172C51.3887 56.1172 50.9707 56.0352 50.623 55.8711C50.2793 55.7031 50.0156 55.4453 49.832 55.0977C49.6484 54.75 49.5566 54.3008 49.5566 53.75V49.5137H50.9395V53.4922C50.9395 53.9961 51.041 54.373 51.2441 54.623C51.4512 54.873 51.7715 54.998 52.2051 54.998C52.623 54.998 52.9551 54.9121 53.2012 54.7402C53.4473 54.5684 53.6211 54.3145 53.7227 53.9785C53.8281 53.6426 53.8809 53.2305 53.8809 52.7422V49.5137H55.2637ZM58.6211 56H57.2383V46.8828H58.6211V56ZM63.1328 49.3906C63.9531 49.3906 64.5723 49.5723 64.9902 49.9355C65.4121 50.2988 65.623 50.8652 65.623 51.6348V56H64.6445L64.3809 55.0801H64.334C64.1504 55.3145 63.9609 55.5078 63.7656 55.6602C63.5703 55.8125 63.3438 55.9258 63.0859 56C62.832 56.0781 62.5215 56.1172 62.1543 56.1172C61.7676 56.1172 61.4219 56.0469 61.1172 55.9062C60.8125 55.7617 60.5723 55.543 60.3965 55.25C60.2207 54.957 60.1328 54.5859 60.1328 54.1367C60.1328 53.4688 60.3809 52.9668 60.877 52.6309C61.377 52.2949 62.1309 52.1094 63.1387 52.0742L64.2637 52.0332V51.6934C64.2637 51.2441 64.1582 50.9238 63.9473 50.7324C63.7402 50.541 63.4473 50.4453 63.0684 50.4453C62.7441 50.4453 62.4297 50.4922 62.125 50.5859C61.8203 50.6797 61.5234 50.7949 61.2344 50.9316L60.7891 49.959C61.1055 49.791 61.4648 49.6543 61.8672 49.5488C62.2734 49.4434 62.6953 49.3906 63.1328 49.3906ZM64.2578 52.9004L63.4199 52.9297C62.7324 52.9531 62.25 53.0703 61.9727 53.2812C61.6953 53.4922 61.5566 53.7812 61.5566 54.1484C61.5566 54.4688 61.6523 54.7031 61.8438 54.8516C62.0352 54.9961 62.2871 55.0684 62.5996 55.0684C63.0762 55.0684 63.4707 54.9336 63.7832 54.6641C64.0996 54.3906 64.2578 53.9902 64.2578 53.4629V52.9004ZM70.8379 49.3906C70.9473 49.3906 71.0664 49.3965 71.1953 49.4082C71.3242 49.4199 71.4355 49.4355 71.5293 49.4551L71.4004 50.7441C71.3184 50.7207 71.2168 50.7031 71.0957 50.6914C70.9785 50.6797 70.873 50.6738 70.7793 50.6738C70.5332 50.6738 70.2988 50.7148 70.0762 50.7969C69.8535 50.875 69.6562 50.9961 69.4844 51.1602C69.3125 51.3203 69.1777 51.5215 69.0801 51.7637C68.9824 52.0059 68.9336 52.2871 68.9336 52.6074V56H67.5508V49.5137H68.6289L68.8164 50.6562H68.8809C69.0098 50.4258 69.1699 50.2148 69.3613 50.0234C69.5527 49.832 69.7715 49.6797 70.0176 49.5664C70.2676 49.4492 70.541 49.3906 70.8379 49.3906ZM74.1074 49.5137V56H72.7305V49.5137H74.1074ZM73.4277 47.0293C73.6387 47.0293 73.8203 47.0859 73.9727 47.1992C74.1289 47.3125 74.207 47.5078 74.207 47.7852C74.207 48.0586 74.1289 48.2539 73.9727 48.3711C73.8203 48.4844 73.6387 48.541 73.4277 48.541C73.209 48.541 73.0234 48.4844 72.8711 48.3711C72.7227 48.2539 72.6484 48.0586 72.6484 47.7852C72.6484 47.5078 72.7227 47.3125 72.8711 47.1992C73.0234 47.0859 73.209 47.0293 73.4277 47.0293ZM78.4961 55.0039C78.6758 55.0039 78.8535 54.9883 79.0293 54.957C79.2051 54.9219 79.3652 54.8809 79.5098 54.834V55.877C79.3574 55.9434 79.1602 56 78.918 56.0469C78.6758 56.0938 78.4238 56.1172 78.1621 56.1172C77.7949 56.1172 77.4648 56.0566 77.1719 55.9355C76.8789 55.8105 76.6465 55.5977 76.4746 55.2969C76.3027 54.9961 76.2168 54.5801 76.2168 54.0488V50.5625H75.332V49.9473L76.2812 49.4609L76.7324 48.0723H77.5996V49.5137H79.457V50.5625H77.5996V54.0312C77.5996 54.3594 77.6816 54.6035 77.8457 54.7637C78.0098 54.9238 78.2266 55.0039 78.4961 55.0039ZM79.8496 49.5137H81.3496L82.6797 53.2168C82.7383 53.3848 82.791 53.5508 82.8379 53.7148C82.8887 53.875 82.9316 54.0332 82.9668 54.1895C83.0059 54.3457 83.0371 54.502 83.0605 54.6582H83.0957C83.1348 54.4551 83.1895 54.2285 83.2598 53.9785C83.334 53.7246 83.416 53.4707 83.5059 53.2168L84.7832 49.5137H86.2656L83.4824 56.8906C83.3223 57.3125 83.125 57.6719 82.8906 57.9688C82.6602 58.2695 82.3867 58.4961 82.0703 58.6484C81.7539 58.8047 81.3926 58.8828 80.9863 58.8828C80.791 58.8828 80.6211 58.8711 80.4766 58.8477C80.332 58.8281 80.209 58.8066 80.1074 58.7832V57.6816C80.1895 57.7012 80.293 57.7188 80.418 57.7344C80.543 57.75 80.6719 57.7578 80.8047 57.7578C81.0508 57.7578 81.2637 57.709 81.4434 57.6113C81.623 57.5137 81.7754 57.375 81.9004 57.1953C82.0254 57.0195 82.1289 56.8184 82.2109 56.5918L82.4395 55.9824L79.8496 49.5137ZM87.0508 55.2734C87.0508 54.9531 87.1328 54.7285 87.2969 54.5996C87.4648 54.4668 87.668 54.4004 87.9062 54.4004C88.1445 54.4004 88.3477 54.4668 88.5156 54.5996C88.6875 54.7285 88.7734 54.9531 88.7734 55.2734C88.7734 55.5859 88.6875 55.8125 88.5156 55.9531C88.3477 56.0898 88.1445 56.1582 87.9062 56.1582C87.668 56.1582 87.4648 56.0898 87.2969 55.9531C87.1328 55.8125 87.0508 55.5859 87.0508 55.2734ZM87.0508 50.2578C87.0508 49.9336 87.1328 49.7051 87.2969 49.5723C87.4648 49.4395 87.668 49.373 87.9062 49.373C88.1445 49.373 88.3477 49.4395 88.5156 49.5723C88.6875 49.7051 88.7734 49.9336 88.7734 50.2578C88.7734 50.5664 88.6875 50.791 88.5156 50.9316C88.3477 51.0684 88.1445 51.1367 87.9062 51.1367C87.668 51.1367 87.4648 51.0684 87.2969 50.9316C87.1328 50.791 87.0508 50.5664 87.0508 50.2578ZM46.498 68.3496C46.498 67.8457 46.5332 67.3496 46.6035 66.8613C46.6777 66.373 46.8027 65.916 46.9785 65.4902C47.1543 65.0645 47.3965 64.6895 47.7051 64.3652C48.0176 64.041 48.4102 63.7871 48.8828 63.6035C49.3555 63.416 49.9238 63.3223 50.5879 63.3223C50.7598 63.3223 50.9531 63.3301 51.168 63.3457C51.3828 63.3613 51.5605 63.3867 51.7012 63.4219V64.5645C51.5488 64.5215 51.3809 64.4883 51.1973 64.4648C51.0176 64.4414 50.8379 64.4297 50.6582 64.4297C49.9395 64.4297 49.3789 64.5664 48.9766 64.8398C48.5742 65.1094 48.2871 65.4805 48.1152 65.9531C47.9434 66.4219 47.8438 66.959 47.8164 67.5645H47.8867C48.0039 67.3691 48.1504 67.1953 48.3262 67.043C48.502 66.8906 48.7168 66.7695 48.9707 66.6797C49.2246 66.5859 49.5195 66.5391 49.8555 66.5391C50.3555 66.5391 50.791 66.6445 51.1621 66.8555C51.5332 67.0625 51.8184 67.3633 52.0176 67.7578C52.2207 68.1523 52.3223 68.6309 52.3223 69.1934C52.3223 69.7988 52.207 70.3203 51.9766 70.7578C51.75 71.1953 51.4258 71.5312 51.0039 71.7656C50.5859 72 50.0879 72.1172 49.5098 72.1172C49.084 72.1172 48.6875 72.0391 48.3203 71.8828C47.957 71.7266 47.6387 71.4922 47.3652 71.1797C47.0918 70.8672 46.8789 70.4766 46.7266 70.0078C46.5742 69.5352 46.498 68.9824 46.498 68.3496ZM49.4863 70.9805C49.9316 70.9805 50.2891 70.8359 50.5586 70.5469C50.832 70.2539 50.9688 69.8066 50.9688 69.2051C50.9688 68.7168 50.8477 68.3301 50.6055 68.0449C50.3672 67.7598 50.0078 67.6172 49.5273 67.6172C49.1992 67.6172 48.9121 67.6875 48.666 67.8281C48.4199 67.9688 48.2285 68.1465 48.0918 68.3613C47.959 68.5762 47.8926 68.7949 47.8926 69.0176C47.8926 69.2441 47.9258 69.4727 47.9922 69.7031C48.0586 69.9336 48.1582 70.1465 48.291 70.3418C48.4238 70.5332 48.5898 70.6875 48.7891 70.8047C48.9883 70.9219 49.2207 70.9805 49.4863 70.9805ZM56.2656 66.6445C56.8164 66.6445 57.3008 66.7441 57.7188 66.9434C58.1406 67.1387 58.4688 67.4277 58.7031 67.8105C58.9375 68.1895 59.0547 68.6543 59.0547 69.2051C59.0547 69.8066 58.9277 70.3262 58.6738 70.7637C58.4199 71.1973 58.0469 71.5312 57.5547 71.7656C57.0625 72 56.4629 72.1172 55.7559 72.1172C55.3066 72.1172 54.8867 72.0781 54.4961 72C54.1094 71.9219 53.7754 71.8047 53.4941 71.6484V70.4062C53.7871 70.5703 54.1387 70.7051 54.5488 70.8105C54.959 70.9121 55.3516 70.9629 55.7266 70.9629C56.125 70.9629 56.4668 70.9043 56.752 70.7871C57.0371 70.6699 57.2559 70.4902 57.4082 70.248C57.5645 70.0059 57.6426 69.6992 57.6426 69.3281C57.6426 68.8359 57.4844 68.457 57.168 68.1914C56.8555 67.9219 56.3652 67.7871 55.6973 67.7871C55.4629 67.7871 55.2129 67.8086 54.9473 67.8516C54.6855 67.8906 54.4668 67.9336 54.291 67.9805L53.6875 67.623L54.0098 63.4336H58.4629V64.6465H55.2227L55.0352 66.7793C55.1758 66.748 55.3438 66.7188 55.5391 66.6914C55.7344 66.6602 55.9766 66.6445 56.2656 66.6445ZM62.0488 63.3105C62.6777 63.3105 63.1543 63.5449 63.4785 64.0137C63.8027 64.4785 63.9648 65.1367 63.9648 65.9883C63.9648 66.8359 63.8086 67.498 63.4961 67.9746C63.1875 68.4512 62.7051 68.6895 62.0488 68.6895C61.4355 68.6895 60.9688 68.4512 60.6484 67.9746C60.3281 67.498 60.168 66.8359 60.168 65.9883C60.168 65.1367 60.3184 64.4785 60.6191 64.0137C60.9238 63.5449 61.4004 63.3105 62.0488 63.3105ZM62.0547 64.2715C61.8008 64.2715 61.6133 64.4141 61.4922 64.6992C61.375 64.9844 61.3164 65.416 61.3164 65.9941C61.3164 66.5684 61.375 67.002 61.4922 67.2949C61.6133 67.584 61.8008 67.7285 62.0547 67.7285C62.3125 67.7285 62.5039 67.584 62.6289 67.2949C62.7578 67.0059 62.8223 66.5723 62.8223 65.9941C62.8223 65.4199 62.7598 64.9902 62.6348 64.7051C62.5098 64.416 62.3164 64.2715 62.0547 64.2715ZM67.8027 63.4336L63.0508 72H61.9199L66.6719 63.4336H67.8027ZM67.6445 66.7383C68.2734 66.7383 68.75 66.9727 69.0742 67.4414C69.4023 67.9062 69.5664 68.5645 69.5664 69.416C69.5664 70.2598 69.4102 70.9199 69.0977 71.3965C68.7891 71.873 68.3047 72.1113 67.6445 72.1113C67.0312 72.1113 66.5645 71.873 66.2441 71.3965C65.9238 70.9199 65.7637 70.2598 65.7637 69.416C65.7637 68.5645 65.9141 67.9062 66.2148 67.4414C66.5195 66.9727 66.9961 66.7383 67.6445 66.7383ZM67.6504 67.6992C67.3965 67.6992 67.209 67.8418 67.0879 68.127C66.9707 68.4121 66.9121 68.8438 66.9121 69.4219C66.9121 69.9961 66.9707 70.4297 67.0879 70.7227C67.209 71.0117 67.3965 71.1562 67.6504 71.1562C67.9121 71.1562 68.1055 71.0137 68.2305 70.7285C68.3555 70.4395 68.418 70.0039 68.418 69.4219C68.418 68.8477 68.3555 68.418 68.2305 68.1328C68.1055 67.8438 67.9121 67.6992 67.6504 67.6992Z"
                              fill="#313131"
                            />
                          </svg>
                        </div>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mb: 0 }}>
                      <Grid item xs={12}>
                        <div className="mt-3 gap-2 flex flex-wrap">
                          <Button
                            variant={exam?.isExamFlagged ? "contained" : "outlined"}
                            style={{
                              textTransform: "none",
                              color: exam?.isExamFlagged ? "#fff" : "#d32f2f", 
                              border: "0.5px solid #d32f2f",
                              backgroundColor: exam?.isExamFlagged ? "#d32f2f" : "transparent",
                              padding: "4px 8px",
                            }}
                            className="flex gap-1"
                            onClick={() => {
                              setExamId(exam);
                              setFlag(true);
                            }}
                          >
                            {!exam?.isExamFlagged ? (
                               <>
                               <OutlinedFlag />
                               Flag
                               </>
                            ) : (
                              <>
                                <Flag />
                                Unflag
                              </>
                            )
                             
                            }
                            
                          </Button>

                          <Button
                            variant="outlined"
                            style={{
                              textTransform: "none",
                              color: "#388e3c", // Green for Verify
                              border: "0.5px solid #388e3c",
                              padding: "4px 8px",
                            }}
                            onClick={() => {
                              setExamId(exam);
                              setVerifyModal(true);
                            }}
                          >
                            {!exam?.locked ? (
                              <>
                                <Verified />
                                Verify
                              </>
                            ) : (
                              <>
                                <Unpublished />
                                Unverify
                              </>
                            )}
                          </Button>

                          <Button
                            variant="outlined"
                            style={{
                              textTransform: "none",
                              color: "#1976d2", // Blue for Edit (pencil)
                              border: "0.5px solid #1976d2",
                              padding: "4px 8px",
                            }}
                            onClick={() => handleExamEdit(exam)}
                          >
                            <Edit />
                            Edit
                          </Button>

                          <Button
                            variant="outlined"
                            style={{
                              textTransform: "none",
                              color: "#d32f2f", // Red for Delete
                              border: "0.5px solid #d32f2f",
                              padding: "4px 8px",
                            }}
                            onClick={() => {
                              setExamId(exam);
                              setDeleteModal(true);
                            }}
                          >
                            <Delete />
                            Delete
                          </Button>
                        </div>
                      </Grid>
                    
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Card
                variant="outlined"
                sx={{ borderRadius: "5px", marginBottom: 14 }}
              >
                <CardContent>
                  <Typography>
                    <div className="text-center font-bold">
                      <h3 className="e-study-heading-two">
                        No questions available
                      </h3>
                    </div>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          )}          
        </Grid>
        }
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <SubjectTopics subjectId={id} />
      </CustomTabPanel>

      <Dialog
        open={deleteModal}
        onClose={() => setDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Paper sx={{ p: 1 }}>
            <h3 className="e-study-heading-three">
              Are you sure you want to delete this exam?
            </h3>
          </Paper>
        </DialogContent>
        <DialogActions>
          <div className="flex justify-between items-center space-x-3 lg:space-x-9">
            <span
              className="e-study-primary cursor-pointer"
              onClick={() => setDeleteModal(false)}
            >
              No
            </span>
            <button
              onClick={() => handleDeleteExam(examId)}
              style={{ backgroundColor: "#FA7E77" }}
              class="hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full"
            >
              Yes
            </button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={VerifyModal}
        onClose={() => setVerifyModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Paper sx={{ p: 1 }}>
            <h3 className="e-study-heading-three">
              Are you sure you want to {examId?.locked ? "unverify" : "verify"} this exam paper?
            </h3>
          </Paper>
        </DialogContent>
        <DialogActions>
          <div className="flex justify-between items-center space-x-3 lg:space-x-9">
            <span
              className="e-study-primary cursor-pointer"
              onClick={() => setVerifyModal(false)}
            >
              No
            </span>
            <button
              onClick={() => handleVerifyExam(examId)}
              style={{ backgroundColor: "#FA7E77" }}
              class="hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full"
            >
              Yes
            </button>
          </div>
        </DialogActions>
      </Dialog>
      <Dialog open={flag} onClose={() => setFlag(false)}>
        <DialogTitle>Flag Comment</DialogTitle>
        <DialogContent>
          {/* Add input field for comment */}
          {examId.isExamFlagged == 1?  (<Typography>
            Are you sure you want to unflag this exam paper ?
          </Typography>) : ( <TextField
            variant="outlined"
            value={flagReason}
            input
            type="text"
            placeholder="Enter your reason"
            onChange={(e) => setFlagReason(e.target.value)}
          />)}
         
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFlag(false)}>Cancel</Button>
          {examId.isExamFlagged == 1 ?  ( <Button
            onClick={() => handleFlagExam(examId)}
          >
            Yes
          </Button>) :(
          <Button
            onClick={() => handleFlagExam(examId)}
          >
            Submit
          </Button>)}
        </DialogActions>
      </Dialog>
      <ToastState />
    </Box>
  );
};

export default ContentUploadExam;
